import { Component, Input, OnChanges, SimpleChanges, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { TableModule } from 'primeng/table';
import { NgIf, NgClass, CommonModule, DatePipe } from '@angular/common';
import { ReportService } from '../../../../services/report.service';
import { finalize, Subscription } from 'rxjs';

import ChartDataLabels from 'chartjs-plugin-datalabels';
import { ChartModule } from 'primeng/chart';
import { ButtonModule } from 'primeng/button';
import { saveAs } from 'file-saver';
import { CommonService } from '../../../../services/common.service';

@Component({
    selector: 'app-tlr-breakdown-report',
    imports: [TableModule, NgIf, NgClass, ChartModule, CommonModule, DatePipe, TableModule, ButtonModule, RouterModule],
    templateUrl: './tlr-breakdown-report.component.html',
    styleUrl: './tlr-breakdown-report.component.scss'
})
export class TlrBreakdownReportComponent implements OnInit {

  initReportData: any[] = []; // Initialize with an empty array or appropriate data structure
  chartData: any;
  chartOptions: any;
  tlrSectionData: any[] = [];
  currentDate: Date = new Date(); // Today's date for the chart title

  tabledataShow: boolean = false;
  plugins = [ChartDataLabels];
  tlrReportDataDetails: any;
  isDetailsBlock: boolean = false;
  sectionTitle: string = '';
  sectionType: string = '';
  paramSub: Subscription | undefined;
  grapFlag: string = '';
  constructor(private route: ActivatedRoute, private reportService: ReportService, private router: Router,
    private commonService: CommonService
  ) {
  }

  ngOnInit() {

    this.paramSub = this.route.queryParams.subscribe(params => {
      if (params['isDetailsBlock'] && params['sectionName'] && params['graphFlag'] && params['sectionType']) {
        this.isDetailsBlock = params['isDetailsBlock'] === 'true';
        this.sectionTitle = params['sectionName'];
        this.grapFlag = params['graphFlag'];
        this.sectionType = params['sectionType'];
        this.getDetailsData(this.sectionTitle, this.grapFlag);
        this.setupChartOptions();
      }
      else {
        this.getReportData();
        this.setupChartOptions();

      }
    });
  }

  setupChartOptions() {
    this.chartOptions = {
      indexAxis: 'x',
      maintainAspectRatio: false,
      aspectRatio: 0.8,
      plugins: {
        tooltip: {
          mode: 'index',
          intersect: false
        },
        legend: {
          labels: {
            color: '#495057'
          },
          position: 'bottom'
        },
        datalabels: {
          display: false // Disable the data labels that appear on top of bars
        }
      },
      scales: {
        x: {
          ticks: {
            color: '#495057',
            font: {
              size: 10
            }
          },
          grid: {
            color: '#ebedef'
          }
        },
        y: {
          ticks: {
            color: '#495057'
          },
          grid: {
            color: '#ebedef'
          },
          beginAtZero: true
        }
      }
    };
  }

  getReportData1() {
    setTimeout(() => {
      this.createMockData();
      this.tabledataShow = true;
    }, 1000);

  }

  getReportData() {
    let payload = {
      graphFlag: 'G',
      userCai: this.commonService.getUserCai(),
      facility: this.reportService.getCurrentFacilityId(),
      sectionName: 'no',
    };
    this.reportService.GetTlrBreakDownReport(payload).subscribe({
      next: (data: any) => {
        this.tlrSectionData = data;
        this.chartData = {
          labels: this.tlrSectionData.map((d: any) => d.Section_Name),
          datasets: [
            // green color
            {
              label: 'Installed',
              data: this.tlrSectionData.map((d: any) => d.Installed),
              backgroundColor: '#22c55e',
              borderColor: '#22c55e',
              borderwidth: 1
            },
            //color: Goldenrod
            {
              label: 'Engineered',
              data: this.tlrSectionData.map((d: any) => d.Engineered),
              backgroundColor: '#f59e0b',
              borderColor: '#f59e0b',
              borderwidth: 1
            },
            //Red color
            {
              label: 'Beyond Due Date',
              data: this.tlrSectionData.map((d: any) => d.Beyond_Due_Date),
              backgroundColor: '#ef4444',
              borderColor: '#ef4444',
              borderwidth: 1
            },
            //Navy color
            {
              label: 'OTR',
              data: this.tlrSectionData.map((d: any) => d.OTR),
              backgroundColor: '#64748b',
              borderColor: '#64748b',
              borderwidth: 1
            },
            //SlateGray color
            {
              label: 'OTR Overdue',
              data: this.tlrSectionData.map((d: any) => d.OTR_Overdue),
              backgroundColor: '#d946ef',
              borderColor: '#d946ef',
              borderwidth: 1
            }

          ]
        }

      },
      error: (error: any) => {
        console.error('Error fetching data:', error);
      }
    });
  }
  getDetails(item: any, type: string, sectionType: string) {
    this.isDetailsBlock = true;
    const queryParams = {
      isDetailsBlock: true,
      graphFlag: type,
      sectionType: sectionType,
      sectionName: item.Section_Name
    };
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: queryParams,
      queryParamsHandling: 'merge', // This will merge the new query params with existing ones
      skipLocationChange: false // Set to true if you don't want to update the browser URL
    });

  }

  getDetailsData(title: string, type: string) {
    let payload = {
      graphFlag: type,
      userCai: this.commonService.getUserCai(),
      facility: this.reportService.getCurrentFacilityId(),
      sectionName: title,
    };
    this.reportService.GetTlrBreakDownReport(payload).subscribe({
      next: (data: any) => {
        this.tlrReportDataDetails = data;
      },
      error: (error: any) => {
        console.error('Error fetching data:', error);
      }
    });
  }
  createMockData() {
    // Create mock data for the table based on the screenshot
    this.tlrSectionData = [
      { section: 'abc', installed: 0, engineered: 0, beyondDueDate: 0, otr: 0, otrOverdue: 0 },
      { section: 'ALKYLATION SECTION', installed: 26, engineered: 0, beyondDueDate: 26, otr: 8, otrOverdue: 8 },
      { section: 'ALKYLATION SECTION1', installed: 0, engineered: 0, beyondDueDate: 0, otr: 0, otrOverdue: 0 },
      { section: 'anbcd', installed: 0, engineered: 0, beyondDueDate: 0, otr: 0, otrOverdue: 0 },
      { section: 'BLENDING AND SHIPPING', installed: 38, engineered: 5, beyondDueDate: 35, otr: 23, otrOverdue: 21 },
      { section: 'COKER SECTION', installed: 53, engineered: 0, beyondDueDate: 53, otr: 39, otrOverdue: 39 },
      { section: 'EF/S R/R', installed: 3, engineered: 0, beyondDueDate: 3, otr: 3, otrOverdue: 0 },
      { section: 'ETP', installed: 26, engineered: 0, beyondDueDate: 23, otr: 15, otrOverdue: 12 },
      { section: 'FCC SECTION', installed: 18, engineered: 0, beyondDueDate: 17, otr: 7, otrOverdue: 7 },
      { section: 'ISOMAX', installed: 75, engineered: 0, beyondDueDate: 70, otr: 35, otrOverdue: 31 },
      { section: 'LPD SECTION', installed: 16, engineered: 0, beyondDueDate: 13, otr: 4, otrOverdue: 3 },
      { section: 'LSFO', installed: 119, engineered: 0, beyondDueDate: 106, otr: 62, otrOverdue: 52 },
      { section: 'MAINTENANCE', installed: 0, engineered: 0, beyondDueDate: 0, otr: 0, otrOverdue: 0 },
      { section: 'SULFUR/ACID/DFH SECTION', installed: 54, engineered: 0, beyondDueDate: 51, otr: 30, otrOverdue: 28 },
      { section: 'test', installed: 0, engineered: 0, beyondDueDate: 0, otr: 0, otrOverdue: 0 },
      { section: 'TEST1', installed: 0, engineered: 0, beyondDueDate: 0, otr: 0, otrOverdue: 0 },
      { section: 'UTILITIES SECTION', installed: 109, engineered: 0, beyondDueDate: 100, otr: 38, otrOverdue: 30 },
      { section: 'V-100 (MKTG)', installed: 0, engineered: 0, beyondDueDate: 0, otr: 0, otrOverdue: 0 }
    ];

    this.prepareChartData();
  }

  prepareChartData() {
    const filteredData = this.tlrSectionData.filter(item =>
      item.installed > 0 || item.engineered > 0 || item.beyondDueDate > 0 || item.otr > 0 || item.otrOverdue > 0
    );
    const labels = filteredData.map(item => {
      // Abbreviate section names for chart
      const words = item.section.split(' ');
      if (words.length > 1) {
        return words.map((word: string) => word.substring(0, 4)).join(' ');
      }
      return item.section.substring(0, 5);
    });

    // Create datasets for the chart
    this.chartData = {
      labels: labels,
      datasets: [
        {
          label: 'Installed',
          backgroundColor: '#22c55e', // Green
          data: filteredData.map(item => item.installed)
        },
        {
          label: 'Engineered',
          backgroundColor: '#f59e0b', // Amber
          data: filteredData.map(item => item.engineered)
        },
        {
          label: 'Beyond Due Date',
          backgroundColor: '#ef4444', // Red
          data: filteredData.map(item => item.beyondDueDate)
        },
        {
          label: 'OTR',
          backgroundColor: '#64748b', // Grey
          data: filteredData.map(item => item.otr)
        },
        {
          label: 'OTR Overdue',
          backgroundColor: '#d946ef', // Purple
          data: filteredData.map(item => item.otrOverdue)
        }
      ]
    };
  }

  processReportData(data: any) {
  }

  exportToExcel() {
    let payload = {
      graphFlag: this.sectionType,
      userCai: this.commonService.getUserCai(),
      facility: this.reportService.getCurrentFacilityId(),
      sectionName: this.sectionTitle,
    };
    this.reportService.GetTlrBreakDownReportExcel(payload)
      .subscribe({
        next: (fileData) => {
          if (fileData) {
            saveAs(fileData, 'TLR-BreakDownbySection.xlsx');
          }
        },
        error: (err) => {
          console.error('Error fetching report details:', err);
        }
      })
  }
  getDateClass(date: Date): string {
    date = new Date(date); // Convert to Date object if it's a string
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time to midnight for comparison

    if (date < today) {
      return 'past-date';
    } else  {
        return 'future-date';
      }
  }



  selectData(event: any) {
    const label = this.chartData.labels[event.element.index];
    const datasetIndex = event.element.datasetIndex;
    const datasetLabel = this.chartData.datasets[datasetIndex].label;
    const sectionData = this.tlrSectionData[event.element.index];

    // Determine which type of data to show based on datasetIndex
    let type = '';
    switch (datasetIndex) {
      case 0:
        type = 'I';  // Installed
        break;
      case 1:
        type = 'E';  // Engineered
        break;
      case 2:
        type = 'B';  // Beyond Due Date
        break;
      case 3:
        type = 'O';  // OTR
        break;
      case 4:
        type = 'D';  // OTR Overdue
        break;
    }

    if (sectionData) {
      this.getDetails(sectionData, type, datasetLabel);
    }
  }
}
